import { SubClauseWithCondition } from "../ars_ldm";
import { isLevelOrder } from "./isLevelOrder";
import { isWhereClauseCondition } from "./isWhereClauseCondition";

/**
 * Type guard to check if a value is a SubClauseWithCondition.
 *
 * @param obj - The value to check
 * @returns True if the value is a SubClauseWithCondition
 */
export const isSubClauseWithCondition = (obj: unknown): obj is SubClauseWithCondition => {
  // Check basic structure
  if (!isLevelOrder(obj)) return false;

  const chkObj = obj as {
    id?: unknown;
    subClauseId?: unknown;
    condition?: unknown;
    compoundExpression?: unknown;
  };

  // Check id is a non-blank string
  if (typeof chkObj.id !== "string" || chkObj.id === "") return false;

  // Check subClauseId is "" (empty string for non-referenced clauses)
  if (chkObj.subClauseId !== "") return false;

  // Must have a valid condition
  if (!isWhereClauseCondition(chkObj.condition)) return false;

  // Must not have compoundExpression property
  if (chkObj.compoundExpression !== undefined) return false;

  return true;
};
